import { Dropdown } from "react-bootstrap";

import {
  Icon,
  CustomDropdownToggle,
  CustomDropdownMenu,
  LinkList,
  LinkListItem,
} from "../../components";
import { createPortal } from "react-dom";

import { MdDelete } from "react-icons/md";
import {
  handleDeleteCoupon,
  handleToggleStatus,
} from "../../pages/coupons/CouponsList";

export const userColumns = ({ setCouponsData }) => {
  return [
    {
      name: " coupon code",
      selector: (row) => row.couponcode,
      cell: (row) => <span>{row.couponcode}</span>,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "start Date",
      selector: (row) => row.start_date,
      cell: (row) => <span>{new Date(row.start_date).toDateString()}</span>,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "End Date",
      selector: (row) => row.end_date,
      cell: (row) => <span>{new Date(row.end_date).toDateString()}</span>,
      sortable: true,
      minWidth: "150px",
    },

    {
      name: "Discount type",
      selector: (row) => row.discount_type,
      cell: (row) => <span>{row.discount_type}</span>,

      sortable: true,
    },
    // {
    //     name: "India Value",
    //     selector: (row) => row.india_value,
    //     cell: (row) => (
    //         <span>
    //             {row.discount_type === "Fixed" ? `₹${row.india_value}` : `${row.india_value}%`}
    //         </span>
    //     ),
    //     sortable: true,
    // },
    {
      name: "Discount Value",
      selector: (row) => row.outside_ind_value,
      cell: (row) => (
        <span>
          {row.discount_type === "Fixed"
            ? `₹${row.outside_ind_value}`
            : `${row.outside_ind_value}%`}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Minimum Amt Required",
      selector: (row) => row.min_amount_required,
      cell: (row) => (
        <span>
          {" "}
          {row.min_amount_required === true ? `Required` : `Not Required`}
        </span>
      ),
      sortable: true,
    },
    // {
    //     name: "India Min Amount",
    //     selector: (row) => row.ind_min_amount,
    //     cell: (row) => (
    //         <span>{row.ind_min_amount}</span>
    //     ),

    //     sortable: true,
    // },
    {
      name: "Min Amount",
      selector: (row) => row.outside_ind_min_amount,
      cell: (row) => <span>{row.outside_ind_min_amount}</span>,

      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.is_active,
      cell: (row) => <span>{row.is_active ? "Active" : "Inactive"}</span>,
      sortable: true,
    },
    {
      name: "action",
      cell: (row) => (
        <div className="text-end w-100">
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              as={CustomDropdownToggle}
              className="btn btn-sm btn-icon btn-zoom me-n1"
            >
              <Icon name="more-v"></Icon>
            </Dropdown.Toggle>
            {createPortal(
              <Dropdown.Menu
                className="dropdown-menu-sm"
                as={CustomDropdownMenu}
                align="end"
              >
                <div className="dropdown-content py-1">
                  <LinkList className="link-list-hover-bg-primary link-list-md">
                    <LinkListItem
                      to={`/coupons-manage/coupons-list/${row.coupon_id}`}
                    >
                      <Icon name="edit"></Icon>
                      <span>Edit</span>
                    </LinkListItem>
                    <LinkListItem
                      className="status-toggle-item"
                      to="#"
                      onClick={() =>
                        handleToggleStatus(
                          row.coupon_id,
                          row.is_active,
                          setCouponsData
                        )
                      }
                    >
                      <Icon name="edit-fill"></Icon>
                      <span>
                        {row.is_active ? "Mark as Inactive" : "Mark as Active"}
                      </span>
                    </LinkListItem>
                    <LinkListItem
                      className="delete-ittem"
                      to="#"
                      onClick={() =>
                        handleDeleteCoupon(row.coupon_id, setCouponsData)
                      }
                    >
                      <MdDelete />
                      <span>Delete</span>
                    </LinkListItem>
                  </LinkList>
                </div>
              </Dropdown.Menu>,
              document.body
            )}
          </Dropdown>
        </div>
      ),
      sortable: false,
    },
  ];
};
